// extracted by mini-css-extract-plugin
export default {"wrap":"F5r58ekeFiOpQP0wNNve","isActive":"H_tJ6MkuRzhdwrtrNgUe","badge":"bBahymuho6Jhns46i_7Q","body":"CmY2dlXfdCaKJonvznNf","footer":"oE25bykEoUFLLAaU992U"};